import { PostType } from 'src/hook/usePosts'

import i18n from 'src/i18n'
import { medias } from 'src/utils/constants'
import { DropZoneUploader } from 'src/components/dropZoneUploader'
import { UploadBoxProps } from './uploadBox.types'

const UploadBox = ({ mediaType, classNames, onSuccess, onLoading, children }: UploadBoxProps) => {
  const dropZoneMediaProps = {
    [PostType.IMAGE]: {
      debug: i18n.t('toasts.video_in_processing'),
      buttonLabel: i18n.t('input_publish.button_send_image'),
      text: i18n.t('input_publish.text_drag_and_drop_v2'),
      disclaimer: i18n.t('input_publish.message_image_format_2'),
      errorMessages: {
        invalidFileType: i18n.t('input_publish.error.invalid_image_format')
      },
      acceptedTypes: medias.image
    },
    [PostType.VIDEO]: {
      buttonLabel: i18n.t('input_publish.button_send_video'),
      text: i18n.t('input_publish.text_drag_and_drop_v2'),
      disclaimer: i18n.t('input_publish.message_video_format_2'),
      errorMessages: {
        invalidFileType: i18n.t('input_publish.error.invalid_video_format')
      },
      acceptedTypes: medias.video
    },
    [PostType.AUDIO]: {
      buttonLabel: i18n.t('input_publish.button_send_audio'),
      text: i18n.t('input_publish.text_drag_and_drop_v2'),
      disclaimer: i18n.t('input_publish.message_audio_format'),
      errorMessages: {
        invalidFileType: i18n.t('input_publish.error.invalid_video_format'),
        invalidAudioDuration: i18n.t('input_publish.error.invalid_audio_duration')
      },
      acceptedTypes: medias.audio
    },
    [PostType.MEDIA]: {
      buttonLabel: i18n.t('input_publish.button_send_media'),
      text: i18n.t('input_publish.text_drag_and_drop_v2'),
      disclaimer: '',
      errorMessages: {
        invalidFileType: i18n.t('input_publish.error.invalid_video_format')
      },
      acceptedTypes: { ...medias.video, ...medias.image }
    }
  }

  const dropZoneProps = dropZoneMediaProps[mediaType]

  return (
    <DropZoneUploader
      {...dropZoneProps}
      className={classNames}
      onLoading={onLoading}
      onSuccess={onSuccess}
    >
      {children}
    </DropZoneUploader>
  )
}

export default UploadBox
